module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainProduct__sizeWrap"
  }, [_c('h5', {
    staticClass: "mainProduct__blockHeader"
  }, [_vm._v(_vm._s(_vm.sizeHeader) + ":")]), _vm._v(" "), _c('ul', {
    staticClass: "mainProduct__sizeList"
  }, _vm._l((_vm.pathSize), function(item, index) {
    return _c('li', {
      key: index,
      attrs: {
        "data-number": index
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.chooseSize.apply(null, arguments)
        }
      }
    }, [_c('a', {
      staticClass: "mainProduct__sizeListItem",
      attrs: {
        "href": "#"
      }
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51049324","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/size.vue
// module id = 53
// module chunks = 0